import { DataFieldType } from "../../../shared/types";
import { DataFieldRuleValidator } from "./types";

export const dataFieldMustContain: DataFieldRuleValidator = {
	validate({ isImplicitlyRequired }, dataFieldType, dataFieldValue, ruleValue): boolean {
		if (dataFieldValue === null || dataFieldValue === undefined) {
			return !isImplicitlyRequired;
		}

		switch (dataFieldType) {
			case DataFieldType.CHECKBOX_GROUP: {
				const value = (dataFieldValue as number[]) ?? [];

				return (ruleValue as number[]).every((x) => value.includes(x));
			}
			case DataFieldType.MULTI_SELECT_FIELD: {
				return (ruleValue as number[]).every((x) => (dataFieldValue as number[]).includes(x));
			}
			case DataFieldType.URL:
			case DataFieldType.EMAIL:
			case DataFieldType.LONG_TEXT:
			case DataFieldType.TEXT:
			case DataFieldType.CRYPT:
			case DataFieldType.PHONE:
				return (dataFieldValue ? (dataFieldValue as string).toLowerCase() : "").includes(
					(ruleValue as string).toLowerCase(),
				);
			case DataFieldType.CHECKBOX:
			case DataFieldType.SELECT_FIELD:
				return ruleValue === dataFieldValue;
			case DataFieldType.RADIO:
				return ruleValue === parseInt(dataFieldValue as string);
		}
		return false;
	},
	getErrorMessage({ t }, dataField, _, ruleValue): string {
		const key = "Field {{name}} must contain {{value}}";
		const values = { name: dataField.label, value: "" };

		switch (dataField.type) {
			case DataFieldType.RADIO:
				values.value = dataField.options.find((x) => x.id === ruleValue)?.value ?? "";
				break;
			case DataFieldType.SELECT_FIELD:
				values.value = dataField.options.find((x) => x.id === ruleValue)?.value ?? "";
				break;
			case DataFieldType.CHECKBOX_GROUP:
			case DataFieldType.MULTI_SELECT_FIELD: {
				const value = ruleValue as number[];
				values.value = dataField.options
					.filter((x) => value.includes(x.id))
					.map((x) => x.value)
					.join(", ");
				break;
			}
			case DataFieldType.CHECKBOX:
				values.value = ruleValue ? "true" : "false";
				break;
			default:
				values.value = ruleValue as string;
		}

		return t(key, values);
	},
};
